import React, { Component } from 'react'
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png'
import { Col } from 'react-bootstrap';
import Footer from '../../components/footer/Footer';
import { responsiveScreenSizesEnum } from '../../utility/enums';
import LoadingScreen from '../../components/loadingScreen/LoadingScreen';
import ExternalNavbar from '../../components/externalNavbar/ExternalNavbar';
import ProductDetail from './ProductDetailDefault';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { updateResponsive, resetResponsive } from '../../redux/actions/responsiveActions';
import MessageBox from '../../components/common/messageBox/MessageBox';
import ProductMagnifier from '../../components/productMagnifier/ProductMagnifier';



/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        userDetails: state.userDetails,
        loadingScreenVisible: state.loadingScreen,
        shoppingPreferences: state.shoppingPreference
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showLoadingScreen,
    hideLoadingScreen,
    updateResponsive,
    resetResponsive
};
class ProductDetailExternal extends Component {
    constructor(props) {
        super();
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <ExternalNavbar />

                <ProductDetail ProductDetail={this.props} />

                <Footer />
                <LoadingScreen isVisible={this.props.loadingScreenVisible} />
                <ProductMagnifier />
                <MessageBox />
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailExternal);